module.exports = __webpack_public_path__ + "portal-static/img/老师.9257c1b7.png";